import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'
import _imports_1 from '@/assets/ilustration-forgot.svg'
import _imports_2 from '@/assets/icons/back-arrow-primary.svg'
import _imports_3 from '@/assets/ilustration-sent.svg'


const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center md:bg-background sm:bg-white" }
const _hoisted_2 = { class: "flex flex-col bg-white md:shadow-md sm:shadow-sm px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-2xl w-full max-w-lg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2/5"
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex flex-col pt-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-1/2"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold pt-10" }, "Forgot your password?", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "pt-4" }, "We will send you the instructions to recover your account", -1)
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "relative flex flex-row items-center justify-center" }
const _hoisted_12 = { class: "flex flex-row justify-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row mt-10" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Back to login")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex flex-col pt-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-1/2"
}, null, -1)
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold pt-10" }, "Email sent", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "pt-4" }, "Don't forget to check your inbox or spam folder.", -1)
const _hoisted_21 = { class: "flex pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.emailSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    name: "email",
                    label: "Email",
                    error: _ctx.fieldErrors.email
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                    class: _normalizeClass(["w-full mt-4", _ctx.loading ? 'btn-filled-lg-loading' : 'btn-filled-lg'])
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_Spinner, {
                            key: 0,
                            color: "white",
                            height: "6",
                            width: "6",
                            border: "2",
                            top: "6"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.loading ? 'ml-4' : '')
                      }, " Reset Password", 2)
                    ])
                  ], 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/login'))),
                class: "text-primary font-medium pl-2"
              }, _hoisted_14)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/login'))),
                    class: "w-full text-white bg-primary rounded-full py-4"
                  }, " Got it ")
                ])
              ])
            ])
          ]))
    ])
  ]))
}